@if (focused) {
  <mat-form-field>
    <mat-label>{{ field().name }}</mat-label>
    <input
      #input
      max="9999-12-31"
      min="1753-01-01"
      matInput
      [ngxMatDatetimePicker]="picker"
      [formControl]="control()"
      [appMultiValueHotkeys]="mvFieldMenu()"
      (blur)="onBlur($event)"
      (focus)="onFocus()"
    />
    <mat-datepicker-toggle
      matSuffix
      [tabIndex]="-1"
      [for]="$any(picker)"
    ></mat-datepicker-toggle>
    @if (field().multiValue && mvFieldMenu()) {
      <button
        [disabled]="control().disabled"
        tabIndex="-1"
        mat-icon-button
        type="button"
        matSuffix
        [matMenuTriggerFor]="mvFieldMenu()!.matMenu"
        [appMultiValueHotkeys]="mvFieldMenu()"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
    }
    <ngx-mat-datetime-picker
      #picker
      [enableMeridian]="true"
      [restoreFocus]="false"
      (closed)="onPickerClosed()"
      [panelClass]="datePickerPanelClass()"
    ></ngx-mat-datetime-picker>
    @if (control().invalid) {
      <mat-error class="ellipsis" [matTooltip]="errorMessage">{{
        errorMessage
      }}</mat-error>
    }
  </mat-form-field>
} @else {
  <mat-form-field>
    <mat-label>{{ field().name }}</mat-label>
    <input
      #maskedInput
      matInput
      type="text"
      [formControl]="maskedControl"
      (focus)="onMaskControlFocus()"
    />
    @if (field().multiValue && mvFieldMenu()) {
      <button
        [disabled]="control().disabled"
        tabIndex="-1"
        mat-icon-button
        type="button"
        matSuffix
        [matMenuTriggerFor]="mvFieldMenu()!.matMenu"
        (click)="$event.stopPropagation()"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
    }
    @if (maskedControl.invalid) {
      <mat-error class="ellipsis" [matTooltip]="maskedErrorMessage">{{
        maskedErrorMessage
      }}</mat-error>
    }
  </mat-form-field>
}
